import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createSlots as _createSlots, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-083eedf1"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EyeOutlined = _resolveComponent("EyeOutlined")!
  const _component_EyeInvisibleOutlined = _resolveComponent("EyeInvisibleOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_UnlockOutlined = _resolveComponent("UnlockOutlined")!
  const _component_LockOutlined = _resolveComponent("LockOutlined")!
  const _component_inline_edit = _resolveComponent("inline-edit")!
  const _component_DragOutlined = _resolveComponent("DragOutlined")!
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createBlock(_component_draggable, {
    list: _ctx.list,
    class: "ant-list-items ant-list-bordered",
    "ghost-class": "ghost",
    handle: ".handle",
    "item-key": "id"
  }, {
    item: _withCtx(({ element }) => [
      _createElementVNode("li", {
        class: _normalizeClass(["ant-list-item", { active: element.id === _ctx.selectedId }]),
        onClick: ($event: any) => (_ctx.handleClick(element.id))
      }, [
        _createVNode(_component_a_tooltip, {
          title: element.isHidden ? '显示' : '隐藏'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              shape: "circle",
              onClick: _withModifiers(($event: any) => (_ctx.handleChange(element.id, 'isHidden', !element.isHidden)), ["stop"])
            }, _createSlots({ _: 2 }, [
              (element.isHidden)
                ? {
                    name: "icon",
                    fn: _withCtx(() => [
                      _createVNode(_component_EyeOutlined)
                    ]),
                    key: "0"
                  }
                : {
                    name: "icon",
                    fn: _withCtx(() => [
                      _createVNode(_component_EyeInvisibleOutlined)
                    ]),
                    key: "1"
                  }
            ]), 1032, ["onClick"])
          ]),
          _: 2
        }, 1032, ["title"]),
        _createVNode(_component_a_tooltip, {
          title: element.isLocked ? '解锁' : '锁定'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              shape: "circle",
              onClick: _withModifiers(($event: any) => (_ctx.handleChange(element.id, 'isLocked', !element.isLocked)), ["stop"])
            }, _createSlots({ _: 2 }, [
              (element.isLocked)
                ? {
                    name: "icon",
                    fn: _withCtx(() => [
                      _createVNode(_component_UnlockOutlined)
                    ]),
                    key: "0"
                  }
                : {
                    name: "icon",
                    fn: _withCtx(() => [
                      _createVNode(_component_LockOutlined)
                    ]),
                    key: "1"
                  }
            ]), 1032, ["onClick"])
          ]),
          _: 2
        }, 1032, ["title"]),
        _createVNode(_component_inline_edit, {
          class: "edit-area",
          value: element.layerName,
          onChange: 
            value => {
              _ctx.handleChange(element.id, 'layerName', value)
            }
          
        }, null, 8, ["value", "onChange"]),
        _createVNode(_component_a_tooltip, { title: "拖动排序" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              shape: "circle",
              class: "handle"
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_DragOutlined)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ], 10, _hoisted_1)
    ]),
    _: 1
  }, 8, ["list"]))
}